import React from 'react';

export type TrashCanProps = {
  fillColor?: string;
};

const TrashCan: React.FC<TrashCanProps> = ({
  fillColor = '#6B7280',
}: TrashCanProps) => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>TrashCan</title>
      <path
        d="M12.4167 0.875V2.66667H0V0.875H3.08333L4 0H8.41667L9.33333 0.875H12.4167ZM0.875 14.2083V3.54167H11.5417V14.2083C11.5417 14.6806 11.3611 15.0972 11 15.4583C10.6389 15.8194 10.2222 16 9.75 16H2.66667C2.19444 16 1.77778 15.8194 1.41667 15.4583C1.05555 15.0972 0.875 14.6806 0.875 14.2083Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default TrashCan;
